import { Flex } from "rebass";

const StyledTag = ({ title, highlighted, bgColor, textColor, isDisabled }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    p="8px 24px"
    css={{
      color: highlighted && !isDisabled ? textColor : "#DEEBF1",
      background: highlighted && !isDisabled ? bgColor : "transparent",
      fontWeight: highlighted && !isDisabled ? 700 : 600,
      border: `1px solid ${highlighted && !isDisabled ? bgColor : "#DEEBF1"}`,
      borderRadius: 50,
      width: "100%",
    }}
  >
    {title}
  </Flex>
);

export default StyledTag;
